export default __webpack_public_path__ + "static/media/logo.da0e18e7.png";